import React from 'react';

const Footer = () => {
    return (
        <footer className="w-full flex flex-col items-center justify-center mb-4">
            <p className="text-primary-400 text-[18px]">
                &copy; 2025  Ricardo André Araújo de Matos
            </p>
        </footer>
    )
}

export default Footer;
